import { i as o } from "./is-object.js";
import { c as r } from "./classof-raw.js";
import { w as s } from "./well-known-symbol.js";
var a = s("match"),
  i = function i(s) {
    var i;
    return o(s) && (void 0 !== (i = s[a]) ? !!i : "RegExp" == r(s));
  };
export { i };